<template>

  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <b-table
      ref="organizationDirectionTable"
      :items="list"
      responsive
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      :empty-text="$t('No matching records found')"
      :sort-desc.sync="isSortDirDesc"
      :busy="isBusy"
      class="position-relative"
    >
      <template #head()="data">
        {{ $t(data.label) }}
      </template>
      <!-- Column: Id -->
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            variant="primary"
            label="Text Centered"
          />
        </div>
      </template>
      <template #cell(name)="data">
        {{ data.item.direction.name[$i18n.locale] }}
      </template>
      <template #cell(code)="data">
        {{ data.item.direction.code }}
      </template>
      <template #cell(category_subject)="data">
        {{ data.item.direction.category_subject.name[$i18n.locale] }}
      </template>
      <!-- Column: Actions -->
      <template #cell(actions)="data">

        <div class="text-nowrap">
          <feather-icon
            v-if="$can('manage', 'All')"
            v-b-toggle.sidebar-create-direction
            icon="EditIcon"
            class="cursor-pointer"
            size="16"
            @click="update(data.item)"
          />
          <feather-icon
            v-if="$can('manage', 'All')"
            icon="TrashIcon"
            class="mx-1 cursor-pointer"
            size="16"
            @click="remove(data.item)"
          />
        </div>
      </template>
    </b-table>
    <create @refetchData="refetchData" />
  </b-card>

</template>

<script>
import {
  BCard, BSpinner, BTable, VBToggle,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import config from './config'
import Create from './Create.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BCard,
    BTable,
    BSpinner,
    Create,
  },
  computed: {
    directions() {
      return this.$store.state[this.MODULE_NAME].org_directions
    },
  },
  created() {
    this.$store.commit(`${this.MODULE_NAME}/FRESH`, this.$route.params.id)
    this.extraParams = { org: this.$route.params.id }
  },
  methods: {
    update(data) {
      this.$store.commit(`${this.MODULE_NAME}/UPDATE`, data)
    },
    remove(data) {
      this.$confirmCode({
        callback: (confirm, smsCode) => {
          if (confirm) {
            this.$createSwal(this, { ...data, smsCode }, `${this.MODULE_NAME}/del`, this.refetchData)
          }
        },
      })
    },
  },
  setup() {
    const MODULE_NAME = 'organizationDirection'
    return {
      ...config(),
      MODULE_NAME,
    }
  },
}
</script>
